module.exports = __webpack_public_path__ + "media/images/uniform-9f54fbea97f2de585d5513b1665949c3.png";